import { LOCATION_CHANGE, CALL_HISTORY_METHOD, routerMiddleware } from 'connected-react-router';

/**
 * NOTE:  This may be unnecessary, and we might be fine using the routerMiddleware
 *      directly - going to leave this here for now, as a possible extension point.
 *
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
const dataRouterMiddleware = (history, customUrlBuilder) => store => next => action => { // eslint-disable-line no-unused-vars
    const isHandledHistoryMethod = action.type === CALL_HISTORY_METHOD;

    if (!isHandledHistoryMethod) {
        return next(action);
    }

    const {
        payload: {
            method,
            args
        }
    } = action;

    let processedArgs = args;

    if (isHandledHistoryMethod) {
        if (customUrlBuilder) {
            const state = store.getState();
            const { views } = state;
            processedArgs = customUrlBuilder(state, views);
        }
    }

    history[method](...processedArgs);
};

export default dataRouterMiddleware;
export { dataRouterMiddleware, routerMiddleware };
